import { reactive } from "vue";

export function useKioskMode() {
  const status = reactive({
    fullscreen: false,
    wakeLock: false,
    orientationLocked: false,
  });

  let wakeLockSentinel = null;

  async function requestFullscreen() {
    if (document.fullscreenElement) {
      status.fullscreen = true;
      return;
    }
    try {
      await document.documentElement.requestFullscreen();
      status.fullscreen = true;
    } catch (error) {
      status.fullscreen = false;
    }
  }

  async function acquireWakeLock() {
    if (!("wakeLock" in navigator)) {
      status.wakeLock = false;
      return;
    }
    try {
      wakeLockSentinel = await navigator.wakeLock.request("screen");
      status.wakeLock = true;
      wakeLockSentinel.addEventListener("release", () => {
        status.wakeLock = false;
      });
    } catch (error) {
      status.wakeLock = false;
    }
  }

  async function lockOrientation() {
    if (!screen.orientation || typeof screen.orientation.lock !== "function") {
      status.orientationLocked = false;
      return;
    }
    try {
      await screen.orientation.lock("landscape");
      status.orientationLocked = true;
    } catch (error) {
      status.orientationLocked = false;
    }
  }

  function handleVisibilityChange() {
    if (document.visibilityState === "visible") {
      acquireWakeLock();
    }
  }

  function start() {
    requestFullscreen();
    acquireWakeLock();
    lockOrientation();
    document.addEventListener("visibilitychange", handleVisibilityChange);
  }

  function stop() {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  }

  async function retryFullscreen() {
    await requestFullscreen();
    await lockOrientation();
  }

  return { status, start, stop, retryFullscreen };
}
